import {
  call,
  put,
  takeEvery,
  takeLatest,
  select,
  throttle,
} from 'redux-saga/effects';

import * as timelineActions from './timeline/actions';
import * as photographerActions from './photographers/actions';
import * as searchTypes from './search/types';
import { BASE_URL } from './index';

const contains = query => name =>
  name && name.toLowerCase().indexOf(query) >= 0;
const getPhotographers = state => state.photographers.data;

function* fetchData(action) {
  yield put(timelineActions.getTimelineEvents());
  yield put(photographerActions.getPhotographers());
  yield put(photographerActions.getCompetitionResult());
}

function* doRequest(action) {
  yield put({ type: action['types'][0] });
  let url = action['url'].startsWith('http') ? '' : BASE_URL;
  url += action['url'];
  const response = yield call(fetch, url);

  if (response.error) {
    yield put({
      type: action['types'][1],
      status: response.status,
      error: response.error,
    });
  } else {
    const json = yield response.json();
    yield put({
      type: action['types'][2],
      status: response.status,
      data: json,
    });
  }
}

function* getInternalSearchResult(action) {
  if (action.query.length < 2) {
    return;
  }
  let photographers = yield select(getPhotographers);
  const query = contains(action.query.toLowerCase());
  photographers = photographers.filter(
    p => query(p.name) || query(p.first_name) || query(p.last_name),
  );
  yield put({
    type: searchTypes.SEARCH_AUTOSUGGEST_SUCCESS,
    suggestions: photographers,
  });
}

function* combinedSaga() {
  yield takeLatest('INIT', fetchData);
  yield takeEvery('CALL_API', doRequest);
  yield throttle(
    1000,
    searchTypes.SEARCH_INPUT_CHANGE,
    getInternalSearchResult,
  );
}

export default combinedSaga;



// WEBPACK FOOTER //
// ./src/sagas.js